<template>
  <ContentWrapper>
    <div class="block-center col-lg-6">
      <!-- START card-->
      <div class="card card-flat">
        <div class="card-header text-center bg-gray" style="font-size:20px;font-weight:bold;">
          YBM Smart LMS Admin
        </div>
        <div class="card-body">
          <div class="p-20">
            <form class="form-horizontal m-t-20" >
              <div class="form-group ">
                <div class="col-12">
                  <input class="form-control" type="text" name="adminId" v-model="data.params.adminId" title="아이디"  placeholder="아이디" maxlength="30" />
                </div>
              </div>

              <div class="form-group">
                <div class="col-12">
                  <input class="form-control" type="password" name="adminPwd" autocomplete="new-password" v-model="data.params.adminPwd" title="비밀번호" placeholder="비밀번호" maxlength="30" />
                </div>
              </div>
              <div class="form-group">
                <div class="col-12">
                    <div class="input-group">
                        <input class="form-control" type="text" v-model="data.params.authCode" placeholder="인증번호" maxlength="6" />
                        <div class="input-group-append ml-2">
                            <button class="btn btn-primary" type="button" @click="getAuthCode()">인증번호 받기</button>
                        </div>
                    </div>
                    <!-- <small class="form-text text-left mt-2">[스마트스쿨] 본인확인을 위해 인증번호(NNNNNN)를 입력해주세요.</small> -->
                </div>
              </div>
              <div class="form-group text-center m-t-40">
                <div class="col-12">
                  <button class="btn btn-primary btn-block text-uppercase waves-effect waves-light" @click="login()"
                          type="button" style=" height: 50px">로그인
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </ContentWrapper>
</template>
<script>
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import {postSsoAdmLogin, postSmsAuthCode} from "@/api/sso/SsoAdmApi";
import store from "@/store/index";
//cfdbe2
export default {
  components: {},
  setup() {

    const data = reactive({
      params:{
        adminId: '',
        // adminId: 'admin',
        adminPwd: '',
        // adminPwd: '11!1',
        authCode: '',
        certSeq: 0,
      },
    })

    const logout = async () => {
      store.commit('setSso', {})
    }
    onMounted(logout);

    return {
      data,
      ...methods(),
    }

  },
}

function methods() {

  // 인증코드 받기
  async function getAuthCode() {
    if (!this.data.params.adminId) {
      alert('아이디를 먼저 입력해주세요.');
      return;
    }
    try {
      // 백엔드에 adminId를 보내 인증번호 SMS 발송을 요청합니다.
      const res = await postSmsAuthCode(this.data.params);
      console.log('res:',res);
      this.data.params.certSeq = res.data.certSeq;
      if (res.data.authCode) {
        this.data.params.authCode = res.data.authCode; // 자동입력 (stg)
      }
      alert(`[${res.data.certReceiver}]로 인증번호가 발송되었습니다. 휴대폰을 확인해주세요.`);
    } catch (error) {
      console.error("인증번호 발송 오류:", error);
      this.data.params.certSeq = 0;
      alert('인증번호 발송 중 오류가 발생했습니다. 관리자에게 문의하세요.');
    }
  }

  // 로그인
  async function login() {
    // 모든 필드 입력 여부 확인 
    if (!this.data.params.adminId || !this.data.params.adminPwd || !this.data.params.authCode) {
      alert('아이디, 비밀번호, 인증번호를 모두 입력해주세요.');
      return;
    }

    const res = await postSsoAdmLogin(this.data.params);
    console.log('res:',res);
    const menuList = res.data.menuList;
    let menuUriList = [];
    menuList.forEach((menu) => {
      if (menu.menuUri) {
        menuUriList.push(menu.menuUri);
      }
      if (menu.subMenuList) {
        menu.subMenuList.forEach((subMenu) => {
          menuUriList.push(subMenu.menuUri);
        })
      }
    })
    let admSso = {
      accessToken: res.data.accessToken,
      socialToken: res.data.socialToken,
      userId: res.data.userId,
      userNm: res.data.userNm,
      roleNm: res.data.roleNm,
      menuList: menuList,
      menuUriList: menuUriList
    }
    this.$store.commit('setSso', admSso)
    this.$router.push("/");
  }

  return {
    login
    ,getAuthCode
  }
}

</script>